import { Field, FieldProps } from 'formik'
import { t } from 'i18next'
import React from 'react'
import { CountryCode, countryData, CountryDetails } from '@kenno/resources'
import { CountrySelect } from '@pandiafi/design-system'

import FormFieldWrapper from 'components/FormField'

type Props = {
  onChange: (
    value: CountryCode | null,
    countryDetails: CountryDetails | null
  ) => void
  required: boolean
}

export const CountryField: React.FC<Props> = ({ onChange, required }) => {
  return (
    <Field name="newAddress.countryCode">
      {({ field, meta }: FieldProps) => (
        <FormFieldWrapper
          name={field.name}
          label={t('terminateContract:labels.countryName')}
          className="min-tablet:flex-1"
          meta={meta}
          labelBold
          required={required}
        >
          <CountrySelect
            {...field}
            countryData={countryData}
            id={field.name}
            onChange={onChange}
          />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
